import { Link, useNavigate } from '@tanstack/react-router';
import { LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { signOut } from '../lib/auth.ts';
import { useSession } from '../lib/session.tsx';
import { ThemeToggle } from './theme-toggle.tsx';

export function TopbarMinimal() {
  const { t } = useTranslation();
  const { user, refresh } = useSession();
  const navigate = useNavigate();

  const onSignOut = async () => {
    try {
      await signOut();
    } catch (err) {
      console.error('[topbar] sign-out failed', err);
    }
    await refresh();
    void navigate({ to: '/' });
  };

  return (
    <header className="sticky top-0 z-50 flex items-center justify-between border-b border-border bg-bg-card/80 backdrop-blur-lg px-4 py-3 xl:hidden">
      <Link to="/" className="font-heading text-lg font-bold text-fg">
        {t('nav.brand')}
      </Link>
      <div className="flex items-center gap-2">
        <ThemeToggle />
        {user ? (
          <button
            type="button"
            onClick={onSignOut}
            aria-label={t('common.signOut')}
            className="inline-flex items-center justify-center size-9 rounded-lg border border-border bg-bg-card text-fg-2 hover:text-error hover:border-error transition-colors duration-260 ease-[var(--ease-out-expo)] cursor-pointer"
          >
            <LogOut className="size-4" />
          </button>
        ) : (
          <Link
            to="/"
            className="text-[13px] font-heading font-bold text-accent hover:underline"
          >
            {t('common.signIn')}
          </Link>
        )}
      </div>
    </header>
  );
}
